<template>
	<div class="aside-wrap">
		<div class="user-aside">
			<div class="userinfo">
				<img :src="item.icon?item.icon:require('@/assets/default-avatar.png')"/>
				<span class="username">#{{item.categoryName}}#</span>
				<div>{{item.content}}</div>
			</div>
		</div>
	</div>
	
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'userAside',
		components: {
			
		},
		props: {
			id: {
				type: String,
				value: ''
			}
		},
		data(){
			return {
				talkId: '',
				userId: '',  //登录用户id
				item: {}
			}
		},
		created(){
			this.talkId = this.id
			this.userId = localStorage.getItem('userId')||''
			this.getTalkInfo()
		},
		methods: {
			async getTalkInfo(){
				let param = {
					talkId: this.talkId
				}
				ajaxParam(param)
				const res = await post('v1/circle/talkInfo', qs.stringify(param))
				this.item = res.data.entity
				console.log(res.data.entity, 11111111111)
			},
			toDetail(){
				this.$router.push({
					path: '/userIndex?id='+this.item.id
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.aside-wrap{
		height: 274px;
		background-color: #fff;
	}
	.user-aside{
		display: flex;
		flex-direction: column;
		width: 100%;
		padding: 40px 0;
		box-sizing: border-box;
		.userinfo{
			display: flex;
			flex-direction: column;
			align-items: center;
			img{
				width: 80px;
				height: 80px;
				border-radius: 50%;
			}
			.username{
				display: block;
				margin: 12px 0 5px;
				font-size: 18px;
				font-weight: bold;
			}
			.userinfo-tips{
				display: block;
				font-size: 12px;
				color: var(--color-text-opacity);
			}
		}
		.user-num-wrap{
			display: flex;
			justify-content: space-around;
			flex: 1;
			margin-top: 20px;
			.user-num-list{
				display: flex;
				flex-direction: column;
				align-items: center;
				border-right: 1px solid var(--color-border);
				flex:1;
			}
			.user-num-list:nth-of-type(3){
				border-right: none;
			}
		}
	}
</style>
